import { render, staticRenderFns } from "./AccountingVatDeclarationPeriodQuarter.vue?vue&type=template&id=fa09e1ac"
import script from "./AccountingVatDeclarationPeriodQuarter.vue?vue&type=script&lang=ts"
export * from "./AccountingVatDeclarationPeriodQuarter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa09e1ac')) {
      api.createRecord('fa09e1ac', component.options)
    } else {
      api.reload('fa09e1ac', component.options)
    }
    module.hot.accept("./AccountingVatDeclarationPeriodQuarter.vue?vue&type=template&id=fa09e1ac", function () {
      api.rerender('fa09e1ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/AccountingVatDeclarationPeriodQuarter.vue"
export default component.exports